import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

const getNewsCategories = async () => {
  const response = await axios.get(`${base_url}country/countries`);
  
  return response.data;
  
};
const createNewsCategory = async (bcat) => {
  const response = await axios.post(`${base_url}country/countries`, bcat, config);

  return response.data;
};
const updateNewsCategory = async (NewsCat) => {
  const response = await axios.put(
    `${base_url}country/countries/${NewsCat.id}`,
    { NewsCat }
  );

  return response.data;
};
const getNewsCategory = async (id) => {
  const response = await axios.get(`${base_url}country/countries/${id}`, config);
  console.log(response.data);
  return response.data;

};

const deleteNewsCategory = async (id) => {
  const response = await axios.delete(`${base_url}country/countries/${id}`, config);

  return response.data;
};
const bCategoryService = {
  getNewsCategories,
  createNewsCategory,
  deleteNewsCategory,
  getNewsCategory,
  updateNewsCategory,
};

export default bCategoryService;
